import {DatePipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Infoprod, Lot, Participation,} from 'src/app/domain';
import {AppeloffreService} from 'src/app/modules/services/appel-offre/appeloffre.service';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {TranslateService} from '@ngx-translate/core';
import {
    DialogListAttachFilesComponent
} from '../../../content-layout/pages/acheteur/appel-offre/proc-passa/ouverture-offres/dialog-list-attach-files/dialog-list-attach-files.component';
import {MatDialog} from '@angular/material/dialog';
import {constantePortail} from '../../../../domain/portail/portail-result';
import {DateFormatTimePipe} from '../../../../modules/pipes/pipes/date-formatwithtime.pipe';

@Component({
    selector: 'app-offer-details',
    templateUrl: './offer-details.component.html',
    styleUrls: ['./offer-details.component.css'],
    providers: [DateFormatTimePipe]
})
export class OfferDetailsComponent implements OnInit {
    public current_lang = this.apptranstlte.getDefaultLang();
    constantePortail = constantePortail;
    form: FormGroup;
    isLoading = false;
    lots: Lot[] = [];
    participations: Participation[] = [];
    infosprodlist: Infoprod[] = [];
    id: any;
    offer: any;
    epBidMasterId = null;
    bidNo = null;
    datatree: any;
    flags = {};
    infoSurAOFicheDetailsAO: any;

    constructor(private datePipe: DatePipe,
                private formBuilder: FormBuilder,
                private offerservice: AppeloffreService,
                private toastService: ToastService,
                private apptranstlte: AppTranslateService,
                private translateS: TranslateService,
                private datepipe: DatePipe,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private dialog: MatDialog,
                private dateFormatTimePipe: DateFormatTimePipe
    ) {
        translateS.onLangChange.subscribe(({lang}) => {
            this.current_lang = lang;
        });
    }

    ngOnInit(): void {
        this.epBidMasterId = this.activatedRoute.snapshot.params.epBidMasterId;
        this.bidNo = this.activatedRoute.snapshot.params.bidNo;
        this.initLablesAndColumns();
        this.initFlags();
        this.getoffres();
        this.get();
        this.getClassification();
        this.getParticipations();
        this.getInfosProd();
    }


    initLablesAndColumns() {
        this.infoSurAOFicheDetailsAO = {};
        this.infoSurAOFicheDetailsAO['title'] = constantePortail.aoInfosCardFicheDetailsAO.title;
        this.infoSurAOFicheDetailsAO['labels'] = constantePortail.aoInfosCardFicheDetailsAO.labels;
        this.infoSurAOFicheDetailsAO['displayedColumns'] = {};
        this.infoSurAOFicheDetailsAO['displayedColumns']['ar'] = constantePortail.aoInfosCardFicheDetailsAO.displayedColumns.ar;
        this.infoSurAOFicheDetailsAO['displayedColumns']['fr'] = constantePortail.aoInfosCardFicheDetailsAO.displayedColumns.fr;
        this.infoSurAOFicheDetailsAO['displayedColumns']['en'] = constantePortail.aoInfosCardFicheDetailsAO.displayedColumns.en;
    }

    initColumnsAnddataColumns2(data) {
        if (data.procedureType === '3') {
            if (!this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].includes('pqRecvEndDtStr2')) {
                this.infoSurAOFicheDetailsAO['labels'].splice(8, 0, 'Dernier délai réception dossiers candidature');
                this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].splice(8, 0, 'pqRecvEndDtStr2');
                this.infoSurAOFicheDetailsAO['displayedColumns']['ar'].splice(8, 0, 'pqRecvEndDtStr2');
                this.infoSurAOFicheDetailsAO['displayedColumns']['en'].splice(8, 0, 'pqRecvEndDtStr2');
                this.infoSurAOFicheDetailsAO['labels'].splice(9, 0, 'Date heure ouverture dossiers candidature');
                this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].splice(9, 0, 'pqOpenDtStr2');
                this.infoSurAOFicheDetailsAO['displayedColumns']['ar'].splice(9, 0, 'pqOpenDtStr2');
                this.infoSurAOFicheDetailsAO['displayedColumns']['en'].splice(9, 0, 'pqOpenDtStr2');
            }
            if (this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].includes('tpRecvEndDtStr2')) {
                this.infoSurAOFicheDetailsAO['labels'].splice(this.infoSurAOFicheDetailsAO['labels'].indexOf('Dernier délai réception propositions techniques'), 1);
                this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].splice(this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].indexOf('tpRecvEndDtStr2'), 1);
                this.infoSurAOFicheDetailsAO['displayedColumns']['ar'].splice(this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].indexOf('tpRecvEndDtStr2'), 1);
                this.infoSurAOFicheDetailsAO['displayedColumns']['en'].splice(this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].indexOf('tpRecvEndDtStr2'), 1);
                this.infoSurAOFicheDetailsAO['labels'].splice(this.infoSurAOFicheDetailsAO['labels'].indexOf('Date heure ouverture propositions techniques'), 1);
                this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].splice(this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].indexOf('tpOpenDtStr2'), 1);
                this.infoSurAOFicheDetailsAO['displayedColumns']['ar'].splice(this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].indexOf('tpOpenDtStr2'), 1);
                this.infoSurAOFicheDetailsAO['displayedColumns']['en'].splice(this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].indexOf('tpOpenDtStr2'), 1);
            }
        } else if (data.procedureType === '4') {
            if (!this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].includes('tpRecvEndDtStr2')) {
                this.infoSurAOFicheDetailsAO['labels'].splice(8, 0, 'Dernier délai réception propositions techniques');
                this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].splice(8, 0, 'tpRecvEndDtStr2');
                this.infoSurAOFicheDetailsAO['displayedColumns']['ar'].splice(8, 0, 'tpRecvEndDtStr2');
                this.infoSurAOFicheDetailsAO['displayedColumns']['en'].splice(8, 0, 'tpRecvEndDtStr2');
                this.infoSurAOFicheDetailsAO['labels'].splice(9, 0, 'Date heure ouverture propositions techniques');
                this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].splice(9, 0, 'tpOpenDtStr2');
                this.infoSurAOFicheDetailsAO['displayedColumns']['ar'].splice(9, 0, 'tpOpenDtStr2');
                this.infoSurAOFicheDetailsAO['displayedColumns']['en'].splice(9, 0, 'tpOpenDtStr2');
            }
            if (this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].includes('pqRecvEndDtStr2')) {
                this.infoSurAOFicheDetailsAO['labels'].splice(this.infoSurAOFicheDetailsAO['labels'].indexOf('Dernier délai réception dossiers candidature'), 1);
                this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].splice(this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].indexOf('pqRecvEndDtStr2'), 1);
                this.infoSurAOFicheDetailsAO['displayedColumns']['ar'].splice(this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].indexOf('pqRecvEndDtStr2'), 1);
                this.infoSurAOFicheDetailsAO['displayedColumns']['en'].splice(this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].indexOf('pqRecvEndDtStr2'), 1);
                this.infoSurAOFicheDetailsAO['labels'].splice(this.infoSurAOFicheDetailsAO['labels'].indexOf('Date heure ouverture dossiers candidature'), 1);
                this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].splice(this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].indexOf('pqOpenDtStr2'), 1);
                this.infoSurAOFicheDetailsAO['displayedColumns']['ar'].splice(this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].indexOf('pqOpenDtStr2'), 1);
                this.infoSurAOFicheDetailsAO['displayedColumns']['en'].splice(this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].indexOf('pqOpenDtStr2'), 1);
            }
        } else {
            if (this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].includes('pqRecvEndDtStr2') || this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].includes('tpRecvEndDtStr2')) {
                this.infoSurAOFicheDetailsAO['labels'].splice(8, 2);
                this.infoSurAOFicheDetailsAO['displayedColumns']['fr'].splice(8, 2);
                this.infoSurAOFicheDetailsAO['displayedColumns']['ar'].splice(8, 2);
                this.infoSurAOFicheDetailsAO['displayedColumns']['en'].splice(8, 2);
            }
        }
    }

    initFlags() {
        this.flags['annonceDisplayed'] = true;
        this.flags['soumissionaireRetenu'] = false;
        this.flags['resultatOuvPublished'] = false;
    }

    getlang() {
        return this.apptranstlte.getDefaultLang();
    }

    get() {
        this.offerservice.findById(this.epBidMasterId).subscribe({
            next: (getoffer) => {

                getoffer['payload']['publicDtStr'] = this.dateFormatTimePipe.transform(getoffer['payload']['publicDt']).toString();
                getoffer['payload']['bdRecvStartDtStr'] = this.dateFormatTimePipe.transform(getoffer['payload']['bdRecvStartDt']).toString();
                getoffer['payload']['bdRecvEndDtStr'] = this.dateFormatTimePipe.transform(getoffer['payload']['bdRecvEndDt']).toString();
                getoffer['payload']['bdOpenDtStr'] = this.dateFormatTimePipe.transform(getoffer['payload']['bdOpenDt']).toString();
                getoffer['payload']['frameworkYnStr'] = getoffer['payload'].frameworkYn == 'Y' ? 'Oui' : 'Non';
                getoffer['payload']['consorYnStr'] = getoffer['payload'].consorYn == 'Y' ? 'Oui' : 'Non';
                getoffer['payload']['generalYnStr'] = getoffer['payload'].generalYn == 'Y' ? 'Oui' : 'Non';
                getoffer['payload']['financingYnStr'] = getoffer['payload'].financingYn == 'Y' ? 'Oui' : 'Non';

                if (getoffer['payload'].pqRecvEndDt && !getoffer['payload'].pqRecvEndDtStr2) {
                    getoffer['payload'].pqRecvEndDtStr2 = this.dateFormatTimePipe.transform(getoffer['payload'].pqRecvEndDt);
                }
                if (getoffer['payload'].pqOpenDt && !getoffer['payload'].pqOpenDtStr2) {
                    getoffer['payload'].pqOpenDtStr2 = this.dateFormatTimePipe.transform(getoffer['payload'].pqOpenDt);
                }

                if (getoffer['payload'].tpRecvEndDt && !getoffer['payload'].tpRecvEndDtStr2) {
                    getoffer['payload'].tpRecvEndDtStr2 = this.dateFormatTimePipe.transform(getoffer['payload'].tpRecvEndDt);
                }
                if (getoffer['payload'].tpOpenDt && !getoffer['payload'].tpOpenDtStr2) {
                    getoffer['payload'].tpOpenDtStr2 = this.dateFormatTimePipe.transform(getoffer['payload'].tpOpenDt);
                }


                this.offer = getoffer['payload'];
                this.initColumnsAnddataColumns2(getoffer['payload']);
                this.checkIfSoumissionaireRetenuResultatPublished('soumissionaireRetenu');
                this.checkIfSoumissionaireRetenuResultatPublished('resultatOuvPublished');

            },
            error: () => {
                this.isLoading = false;
                this.toastService.error('server_error');
            },
            complete: () => {
                this.isLoading = false;
            },
        });
    }

    getClassification() {
        this.offerservice.getClassificationList(this.bidNo).subscribe({
            next: (getclassification) => {

                this.lots = getclassification['payload'];

            },
            error: () => {
                this.isLoading = false;
                this.toastService.error('server_error');
            },
            complete: () => {
                this.isLoading = false;
            },
        });
    }

    getoffres() {
        this.offerservice
            .getOffretree(this.bidNo)
            .subscribe((res) => {
                this.datatree = res['payload'];
            });
    }

    getParticipations() {
        this.offerservice.getParticipationList(this.bidNo).subscribe({
            next: (getparticipation) => {
                this.participations = getparticipation['payload'];
            },
            error: () => {
                this.isLoading = false;
                this.toastService.error('server_error');
            },
            complete: () => {
                this.isLoading = false;
            },
        });
    }

    getInfosProd() {
        this.offerservice.getInfoProdList(this.bidNo).subscribe({
            next: (getinfoprod) => {
                this.infosprodlist = getinfoprod['payload'];
                // this.infosprodlist.filter((column) => {
                //     this.datePipe.transform(column.deliveryEndDtStr, "yyyy-MM-dd");
                //      column.deliveryEndDtStr = moment(column.deliveryEndDtStr._d).format("YYYY-MM-DD");
                //   });
            },
            error: () => {
                this.isLoading = false;
                this.toastService.error('server_error');
            },
            complete: () => {
                this.isLoading = false;
            },
        });
    }

    checkIfSoumissionaireRetenuResultatPublished(ourCase) {

        const reqParams = {
            bidNo: this.offer.bidNo,
            bidModSeq: this.offer.bidModSeq
        };
        this.offerservice.getResultData(ourCase, null, reqParams, 'portail', 'GET').subscribe({
            next: (response) => {

                if (response['code'] == '200') {
                    this.flags[ourCase] = response['payload'] === 'Y';
                } else {
                    this.toastService.error('server_error');
                }
            },
            error: (e) => {

                this.toastService.error('server_error');
            },
            complete: () => {

            }
        });
    }

    openFicheListSoumissionaires() {
        if (this.flags['soumissionaireRetenu']) {

            // this.router.navigate([this.router.url, 'listSoumissionaires']);
            this.router.navigate([
                '/portail/offres/details',
                this.epBidMasterId,
                this.bidNo,
                'listSoumissionaires'
            ]);
        }
    }

    openFicheResultatOuverture() {
        if (this.flags['resultatOuvPublished']) {
            this.router.navigate([
                '/portail/offres/details',
                this.epBidMasterId,
                this.bidNo,
                'resultatouverture'
            ]);
        }
    }

    openDialogListAttachedFiles(data: any) {

        const bidInfos = () => {
            if (data.code === 'listAnnoncesPortailAttachFiles') {
                return {
                    bidNo: data.element.bidNo,
                    bidModSeq: data.element.bidModSeq,
                    // funcType:  data.element.funcType,
                    funcType: '1',
                };
            }
        };

        const dialogRef = this.dialog.open(DialogListAttachFilesComponent, {
            disableClose: true,
            width: '90rem',
            direction: this.apptranstlte.getDir(),
            data: {
                dialogTitle: 'Pièces jointes',
                cardTitle: 'Liste pièces jointes',
                bidInfos: {
                    ...bidInfos(),
                    code: data.code,
                },
            },
        });
        dialogRef.afterClosed().subscribe((result) => {

        });
    }

    private createField(name: string, label: string) {
        return {name, label};
    }
}
